<template>
  <header class="navbar navbar-expand-lg navbar-dark custom-navbar">
    <div class="container">
      <router-link to="/" class="navbar-brand">
        <img src="@/assets/images/logos/living-dna-updated-logo.svg" alt="Logo" />
      </router-link>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" @click="activeTab = 'dashboard'">
            <router-link to="/" :class="{ actives: (isActive('/') && activeTab === '') || activeTab === 'dashboard' }"
              class="nav-link dropdown-toggle">
              Home
            </router-link>
          </li>
          <li class="nav-item" ref="ancestryMenu">
            <router-link to="" class="nav-link dropdown-toggle" :class="{
              actives: (isActive([
                '/viking',
                '/ancestry/overview',
                '/motherline/overview',
                '/fatherline/overview',
                '/family-matching/list',
                '/vikings/overview',
                '/archaic/overview',
                '/classical-overview',
                '/ancestry/recent',
                '/ancestry/versions',
                '/ancestry/book-pdf',
                '/motherline/history',
                '/motherline/distribution-map',
                '/motherline/migration-map',
                '/fatherline/history',
                '/fatherline/distribution-map',
                '/fatherline/migration-map',
                '/family-matching/messaging-center',
                '/family-matching/matchbox',
                '/family-matching/multiview-browser',
                '/vikings/results',
                '/vikings/maps',
                '/archaic/maps',
                '/archaic/results',
                '/archaic/traits',
                '/archaic/references',
                '/roman-overview',
                '/greek-overview',
                '/egyptian-overview',
              ]) && activeTab === '') || activeTab === 'ancestery',
            }" @click.prevent="handleAncestryDesktopClick">Ancestry <svg class="menu-arrow" viewBox="0 0 24 24"
                role="img" aria-label="Arrow pointing to the right">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
              </svg></router-link>
            <div class="custom-dropdown mega-menu" :class="{ 'show': activeSubMenuUpIndex === 0 }">
              <div class="container">
                <div class="row">
                  <div class="col-sm-8 p-0">
                    <div class="list-of-category">
                      <div class="list">
                        <router-link to="/ancestry" :class="{
                          actives: isActive([
                            '/ancestry/overview',
                            '/ancestry/recent',
                            '/ancestry/versions',
                            '/ancestry/book-pdf',
                          ]),
                        }">
                          <span><img src="@/assets/header/Autosomal.svg" /></span>
                          <label>Recent Ancestry</label>
                        </router-link>
                      </div>
                      <div class="list">
                        <router-link to="/motherline" :class="{
                          actives: isActive([
                            '/motherline/overview',
                            '/motherline/history',
                            '/motherline/distribution-map',
                            '/motherline/migration-map',
                          ]),
                        }">
                          <span><img src="@/assets/header/Motherline.svg" /></span>
                          <label>Motherline</label>
                        </router-link>
                      </div>
                      <div class="list">
                        <router-link to="/fatherline" :class="{
                          actives: isActive([
                            '/fatherline/overview',
                            '/fatherline/history',
                            '/fatherline/distribution-map',
                            '/fatherline/migration-map',
                          ]),
                        }">
                          <span><img src="@/assets/header/Fatherline.svg" /></span>
                          <label>Fatherline</label>
                        </router-link>
                      </div>
                      <div class="list">
                        <router-link to="/family-matching" :class="{
                          actives: isActive([
                            '/family-matching/list',
                            '/family-matching/messaging-center',
                            '/family-matching/matchbox',
                            '/family-matching/multiview-browser',
                          ]),
                        }">
                          <span><img src="@/assets/header/FamilyMatching.svg" /></span>
                          <label>Family Matching</label>
                        </router-link>
                      </div>
                      <div class="list">
                        <router-link to="/vikings" :class="{
                          actives: isActive([
                            '/vikings/overview',
                            '/vikings/results',
                            '/vikings/maps',
                          ]),
                        }">
                          <span><img src="@/assets/header/Viking.svg" /></span>
                          <label>Viking</label>
                        </router-link>
                      </div>
                      <div class="list">
                        <router-link to="/archaic" :class="{
                          actives: isActive([
                            '/archaic/overview',
                            '/archaic/maps',
                            '/archaic/results',
                            '/archaic/traits',
                            '/archaic/references',
                          ]),
                        }">
                          <span><img src="@/assets/header/Archaic.svg" /></span>
                          <label>Neanderthal</label>
                        </router-link>
                      </div>
                      <div class="list">
                        <router-link to="/classical" :class="{
                          actives: isActive([
                            '/classical/overview',
                            '/classical/roman',
                            '/classical/greek',
                            '/classical/egyptian',
                          ]),
                        }">
                          <span><img src="@/assets/header/Classical.svg" /></span>
                          <label>Classical</label>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <UnlockSection v-if="buildVersion !== 'dnanalysis'" :locktitle="unlockTitle"
                      :lockimage="unlockImage" :locklink="unlockLink" :lockrate="unlockrate" />
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item" ref="healthMenu" v-if="buildVersion !== 'dnanalysis' && hasHealthProfileAccess">
            <router-link to="" :class="{
              actives: (isActive([
                '/blood/test',
                '/nutrigenomics',
                '/health/genetics/reports',
                '/health/wellbeing',
                '/health/supplements',
                '/health/genetics/category',
                '/epigenetics',
                '/bakers',
                '/detail/taste-sensitivity',
                '/detail/smell-sensitivity',
                '/detail/metabolism',
                '/detail/handling',
                '/epigenetics'
              ]) && activeTab === '') || activeTab === 'health',
            }" class="nav-link dropdown-toggle" @click.prevent="toggleSubUpMenu(1), activeTab = 'health'">Health <svg
                class="menu-arrow" viewBox="0 0 24 24" role="img" aria-label="Arrow pointing to the right">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
              </svg></router-link>
            <div class="custom-dropdown mega-menu health-section" :class="{ 'show': activeSubMenuUpIndex === 1 }">
              <div class="container">
                <div class="row">
                  <div class="col-sm-6 p-0">
                    <div class="list-of-category health-catergory">
                      <div class="list" v-if="hasBloodTests">
                        <router-link :class="{
                          actives: isActive(['/blood/test']),
                        }" to="/blood/test">
                          <span><img src="@/assets/header/img1.svg" /></span>
                          <label>Blood Tests</label>
                        </router-link>
                      </div>
                      <div class="list">
                        <router-link :class="{
                          actives: isActive(['/health/genetics/reports']),
                        }" to="/health/genetics/reports">
                          <span><img src="@/assets/header/GeneticHealth.svg" /></span>
                          <label>
                            Genetics
                          </label>
                        </router-link>
                      </div>
                      <!-- <div class="list">
                        <span><img src="@/assets/header/img3.svg" /></span>
                        <label
                          ><router-link to="/nutrigenomics"
                            >Health Profile</router-link
                          ></label
                        >
                      </div> -->

                      <div class="list" v-if="!useNewWellbeing && buildVersion !== 'dnanalysis'">
                        <router-link :class="{
                          actives: isActive(['/health/wellbeing']),
                        }" to="/health">
                          <span><img src="@/assets/header/Wellbeing.svg" /></span>
                          <label>Wellbeing</label>
                        </router-link>
                      </div>
                      <div class="list">
                        <a href="#" :class="{
                          actives: isActive(['/health/epigenetics']),
                        }" @click.prevent="onEpigeneticsClick">
                          <span><img src="@/assets/header/img4.svg" /></span>
                          <label>Epigenetics</label>
                        </a>
                      </div>
                      <div class="list">
                        <router-link :class="{
                          actives: isActive(['/health/supplements']),
                        }" :to="{ name: 'supplements' }">
                          <span><img src="@/assets/header/img8.svg" /></span>
                          <label>Supplements</label>
                        </router-link>
                      </div>
                      <div class="list"
                        v-if="bakersResult && Object.keys(bakersResult.traits).length && !useNewBaker && buildVersion !== 'dnanalysis'">
                        <router-link :class="{
                          actives: isActive(['/bakers/overview']),
                        }" to="/bakers/overview"> <span><img src="@/assets/bakers/bakerlogo.png" /></span>
                          <label>Bakers</label> </router-link> </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <HealthSection v-if="buildVersion !== 'dnanalysis'" :locktitle="healthTitle"
                      :lockimage="healthImage" :locklink="healthLink" :lockrate="healthrate" :locktype="healthType" />
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item store-nav-item" @click="activeTab = 'store'">
            <router-link to="/store" :class="{
              actives: (isActive(['/store']) && activeTab === '') || activeTab === 'store',
            }" class='nav-link dropdown-toggle'>Store</router-link>
          </li>
        </ul>
      </div>

      <!-- -->

      <div class="right-bar">
        <!-- <div class="setting-icon">
          <img src="@/assets/setting.svg" alt="Logo" />
        </div>
        <div class="notification-icon">
          <img src="@/assets/notification.svg" alt="Logo" />
          <span class="dot"></span>
        </div> -->
        <div class="navbar-collapse show-view">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown profile-dropdown">
              <a class="nav-link dropdown-toggle">
                <div class="profile-avatar">
                  <div class="profile-img">
                    <img v-if="profile?.photo && profile.photo !== 'null'" :src="profile.photo" alt="profile" />
                    <div v-else class="profile-initials">{{ profileInitials }}</div>
                  </div>
                  <div class="profile-name">
                    <span>{{ profile?.name }}</span>
                    <label>{{ profile?.countryOfBirth }}</label>
                  </div>
                </div>
              </a>
              <div class="profile-sub-menu dropdown-menu">
                <router-link class="dropdown-item flex-row-icon" :to="{ name: 'profiles' }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="6" r="4" stroke="#d6d6d6" stroke-width="1.5" />
                    <path
                      d="M19.9975 18C20 17.8358 20 17.669 20 17.5C20 15.0147 16.4183 13 12 13C7.58172 13 4 15.0147 4 17.5C4 19.9853 4 22 12 22C14.231 22 15.8398 21.8433 17 21.5634"
                      stroke="#d6d6d6" stroke-width="1.5" stroke-linecap="round" />
                  </svg>Profiles
                </router-link>

                <a class="dropdown-item flex-row-icon" href="#" @click="openModal">
                  <img :src="ChangeProfileIcon" alt="" />Change Profile
                </a>
                <a class="dropdown-item flex-row-icon" href="#" @click="openhelpModal">
                  <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none"
                    class="">
                    <path
                      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                      stroke="#d6d6d6" stroke-width="2" />
                    <path
                      d="M10.5 8.67709C10.8665 8.26188 11.4027 8 12 8C13.1046 8 14 8.89543 14 10C14 10.9337 13.3601 11.718 12.4949 11.9383C12.2273 12.0064 12 12.2239 12 12.5V12.5V13"
                      stroke="#d6d6d6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 16H12.01" stroke="#d6d6d6" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>Help
                </a>
                <a class="dropdown-item flex-row-icon" href="#" @click="logout">
                  <img :src="LogoutIcon" alt="" />Sign out
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- For Mobile Menu Section -->
      <button class="navbar-toggler" ref="toggler" type="button" @click="toggleMenu" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <nav ref="sidebar" class="mobile-menu" :class="{ active: menuActive }">
        <div class="m-logo">
          <router-link to="/" class="navbar-brand"><img src="@/assets/images/logos/living-dna-updated-logo.svg"
              alt="Logo" /></router-link>
        </div>
        <ul>
          <li>
            <router-link to="/" class="nav-link dropdown-toggle" :class="{ actives: isActive('/') }">
              Home
            </router-link>
          </li>
          <li class="has-children">
            <a href="#" @click.prevent="handleAncestryMobileClick">Ancestry<span class="icon-arrow"></span></a>
            <ul class="children" v-show="activeSubMenuIndex === 0">
              <li>
                <router-link :class="{ actives: isActive('/ancestry/overview') }" to="/ancestry">Recent
                  Ancestry</router-link>
              </li>
              <li>
                <router-link :class="{ actives: isActive('/motherline/overview') }"
                  to="/motherline">Motherline</router-link>
              </li>
              <li>
                <router-link :class="{ actives: isActive('/fatherline/overview') }"
                  to="/fatherline">Fatherline</router-link>
              </li>
              <li>
                <router-link :class="{ actives: isActive('/family-matching/list') }" to="/family-matching">Family
                  Matching</router-link>
              </li>
              <li>
                <router-link :class="{ actives: isActive('/vikings/overview') }" to="/vikings">Viking</router-link>
              </li>
              <li>
                <router-link :class="{ actives: isActive('/archaic/overview') }" to="/archaic">Neanderthal</router-link>
              </li>
              <li>
                <router-link :class="{ actives: isActive('/classical/overview') }"
                  to="/classical">Classical</router-link>
              </li>
            </ul>
          </li>
          <li class="has-children">
            <a href="#" @click.prevent="toggleSubMenu(1)">Health <span class="icon-arrow"></span></a>
            <ul class="children" v-show="activeSubMenuIndex === 1">
              <li v-if="hasBloodTests">
                <router-link :class="{ actives: isActive('/blood/test') }" to="/blood/test">Blood Tests</router-link>
              </li>
              <li>
                <router-link :class="{ actives: isActive('/health/genetics/reports') }"
                  to="/health/genetics/reports">Genetics</router-link>
              </li>
              <!-- <li>
                <router-link
                  :class="{ actives: isActive('/nutrigenomics') }"
                  to="/nutrigenomics"
                  >Health Profile</router-link
                >
              </li> -->
              <li v-if="!useNewWellbeing && buildVersion !== 'dnanalysis'">
                <router-link :class="{ actives: isActive('/health/wellbeing') }" to="/health">Wellbeing</router-link>
              </li>
              <li>
                <a href="#" :class="{ actives: isActive('/health/epigenetics') }"
                  @click.prevent="onEpigeneticsClick">Epigenetics</a>
              </li>
              <li>
                <router-link :class="{ actives: isActive('/health/supplements') }"
                  to="/health/supplements">Supplements</router-link>
              </li>
              <li>
                <router-link
                  v-if="bakersResult && Object.keys(bakersResult.traits).length && !useNewBaker && buildVersion !== 'dnanalysis'"
                  :class="{ actives: isActive('/bakers/overview') }" to="/bakers/overview">Bakers</router-link>
              </li>
            </ul>
          </li>
          <li>
            <router-link to="/store" class="nav-link dropdown-toggle" :class="{ actives: isActive('/store') }">
              Store
            </router-link>
          </li>
          <!-- <li><a href="contact.html">Contact</a></li> -->
        </ul>
      </nav>
      <div class="overlay" v-show="menuActive" :class="{ actives: menuActive }" @click="toggleMenu"></div>
    </div>
    <!-- End For Mobile Menu Section -->
  </header>
  <ResultMessageModal v-model:isVisible="isResultModalVisible" @close="closeModal" />
  <AncestryDontMessageModal v-model:isVisible="isAncestryDontModalVisible" @close="closeModal" />
  <HealthTestMessageModal v-model:isVisible="isHealthTestMessageModalVisible" @close="closeModal" />
  <HealthTestDontMessageModal v-model:isVisible="isHealthTestDontMessageModalVisible" @close="closeModal" />
  <UpgradeMessageModal v-model:isVisible="isUpgradeMessageModalVisible" @close="closeModal" />

  <!-- <ModalView :isVisible="isModalVisible" @close="closeModal">
    <AlertModal :isModalVisible="isModalVisible" @close="closeModal" />
  </ModalView> -->
  <ModalView :title="'Change Profile'" :isVisible="componentsStore.showChangeProfileModal" @close="closeModal">
    <SwitchProfileModal :isModalVisible="componentsStore.showChangeProfileModal" :domain="navChooserDomain" @close="closeModal" />
  </ModalView>
  <ModalView :title="'Epigenetics'" :isVisible="showEpiIntroModal" @close="closeModal">
    <EpigeneticsIntro @close="closeModal" @explore="exploreEpigeneticKits" />
  </ModalView>
  <ModalView class="help-modal" :title="'Help'" :isVisible="componentsStore.showChangeHelpModal" @close="closeModal">
    <SwitchHelpModal :isModalVisible="componentsStore.showChangeHelpModal" @close="closeModal" />
  </ModalView>
</template>

<script>
import { useRoute } from "vue-router";
import ProfileIcon from "@/assets/images/Icons/style=linear.png";
import ChangeProfileIcon from "@/assets/images/Icons/Mask group (6).png";
import LogoutIcon from "@/assets/images/Icons/Vector (1).png";
import "@/styles/components/header.scss";
import store from "@/store/index";
import { useNewWellbeing, useNewBaker, checkProfileManager } from '@/services/health/health';
import { getBakersResult } from '@/services/bakers';
import apiClient from "@/axios";
import endpoints from "@/endpoints";
import { getAllProducts } from "@/store/store/store";
import UnlockSection from "@/components/header/UnlockSection.vue";
import HealthSection from "@/components/header/HealthSection.vue"
import ModalView from "@/components/Modal/ModalView.vue";
import { isAuthenticated } from "@/services/auth";
import SwitchProfileModal from "./Modal/SwitchProfile.vue";
import SwitchHelpModal from "./Modal/SwitchHelp.vue";
import EpigeneticsIntro from "./Modal/EpigeneticsIntro.vue";
import { useAccountProfiles } from "@/composables/useAccountProfiles";
import { useProfileDomain, HEALTH, ANCESTRY } from "@/composables/useProfileDomain";
import { useComponentsStore } from "@/store/modules/components"
import { isEmpty } from "lodash";
import { ref, onMounted, computed } from 'vue'
import ProductService from "@/services/product";
import { groupBy } from "lodash";
import { usePatientStore } from "@/store/health/blood";

import ResultMessageModal from "@/components/Dashboard/ResultMessageModal.vue";
import AncestryDontMessageModal from "@/components/Dashboard/AncestryDontMessageModal.vue";
import HealthTestMessageModal from "@/components/Dashboard/HealthTestMessageModal.vue";
import HealthTestDontMessageModal from "@/components/Dashboard/HealthTestDontMessageModal.vue";
import UpgradeMessageModal from "@/components/Dashboard/UpgradeMessageModal.vue"
import { menuClickCount } from '@/store/menuStore.js';

const ancestryKeys = ['Digital upgrade', 'Kit', 'Vitamins supplement', 'Merchandise'];
const healthKeys = ['Genetic Test'];
const portalKits = [
  "Members-Ancestry-Kit",
  "Members-Ancestry-Wellbeing-Kit",
  "Members-Wellbeing-Kit",
];

function productIsSaleable(product) {
  return product.categories !== "Kit" || portalKits.includes(product.slug);
}
const getPrice = (price) => {
  if (price && price.isOnSale) {
    return price.sale / 100;
  }
  if (price && price.base) {
    return price.base / 100;
  }
  if (price === 0) {
    return "FREE";
  }
  return 0;
}

export default {
  name: "HeaderSection",
  // Component logic
  components: {
    ModalView,
    SwitchProfileModal,
    SwitchHelpModal,
    EpigeneticsIntro,
    UnlockSection,
    HealthSection,
    ResultMessageModal,
    AncestryDontMessageModal,
    HealthTestMessageModal,
    HealthTestDontMessageModal,
    UpgradeMessageModal,
  },
  setup() {
    const route = useRoute(); // Highlighted Line
    const componentsStore = useComponentsStore();
    const patientStore = usePatientStore();
    const hasHealthProfileAccess = ref(true);
    const buildVersion = store.getters.profile?.chipType?.type;
    const activeTab = ref('');
    const myProfile = store.getters.profile?.profile;
    const storeList = ref("");
    const products = ref("");
    const unlockTitle = ref("");
    const unlockImage = ref("");
    const unlockrate = ref("");
    const unlockLink = ref("");
    const healthImage = ref("");
    const healthTitle = ref("");
    const healthLink = ref("");
    const healthType = ref("");
    const healthrate = ref("");
    const productList = ref([]);
    const isResultModalVisible = ref(false);
    const isAncestryDontModalVisible = ref(false);
    const isHealthTestMessageModalVisible = ref(false);
    const isHealthTestDontMessageModalVisible = ref(false);
    const isUpgradeMessageModalVisible = ref(false);
    const bakersResult = ref(null);
    const loadingStatus = ref("loading");

    const kitTests = computed(() => store.getters.kitTests);
    // Single source of truth for the current domain (was a local endsWith('E') check).
    const { isHealthContext: isEpigenetics } = useProfileDomain();
    const epigeneticsProfileId = computed(() => store.getters.profile?.profile?.id);

    // Ancestry/Health nav-entry resolution (shared engine).
    const { resolveDomainEntry, switchToProfile } = useAccountProfiles();
    const showEpiIntroModal = ref(false);
    const navChooserDomain = ref(null); // domain filter passed to the switcher for "choose"
    const loginCount = store.state.loginCount;
    const showOnboardingModals = () => {
      const withAncestry = kitTests.value?.autosomal?.complete;
      const healthKit = kitTests.value?.injuryRisk?.complete;
      console.log("Menu click " + menuClickCount.value);
      // console.log("Login click "+loginCount);
      const ancestryVisit = localStorage.getItem('ancestry_visit_page');
      const healthtestVisit = localStorage.getItem('health_test_page');
      const upgradeVisit = localStorage.getItem('upgrade_test_page');


      if (loginCount === 1 && (menuClickCount.value == 24 || menuClickCount.value == 12 || menuClickCount.value == 5) && !ancestryVisit) {
        localStorage.setItem('ancestry_visit_page', 1);

        if (withAncestry) {
          isResultModalVisible.value = true;
        } else {
          isAncestryDontModalVisible.value = true;
        }
      } else if (loginCount === 2 && menuClickCount.value == 4 && !healthtestVisit && buildVersion !== 'dnanalysis') {
        localStorage.setItem('health_test_page', 1);
        if (healthKit) {
          isHealthTestMessageModalVisible.value = true;
        } else {
          isHealthTestDontMessageModalVisible.value = true;
        }
      }
      else if (loginCount === 3 && menuClickCount.value == 6 && !upgradeVisit) {
        localStorage.setItem('upgrade_test_page', 1);
        isUpgradeMessageModalVisible.value = true;
      }
    };
    const getBakersData = async () => {
      try {
        // Baker is a digital upgrade — the results only exist when the barcode actually
        // has the baker test. A fresh upload / kit without that upgrade has none, so don't
        // even attempt the fetch (it otherwise errors with an undefined GraphQL result).
        const { data: rawKitTests } = await apiClient.get(`${endpoints.kitTests}/${myProfile.barcode}`);
        const hasBaker = Array.isArray(rawKitTests) && rawKitTests.some(t => t.type === 'baker');
        if (!hasBaker) {
          bakersResult.value = null;
          loadingStatus.value = "loaded";
          return;
        }
        const res = await getBakersResult(myProfile.barcode);
        bakersResult.value = res.results ? JSON.parse(res.results) : null;
        loadingStatus.value = "loaded";
      } catch (e) {
        console.error(e);
        loadingStatus.value = "loadingFailed";
      }
    };
    const getStoreList = async () => {
      let data = {};
      try {
        data = await ProductService.getAllProducts(myProfile?.barcode);
        products.value = data;

      } catch (error) {
        console.error('Error fetching product data:', error);
      }

      if (data) {
        data = Array.isArray(data) ? data : [];
        const saleableProducts = data.filter(product => {
          return productIsSaleable(product);
        });
        const nonPurchasedProducts = saleableProducts.filter(product => {
          return product.purchased === false;
        });
        storeList.value = groupBy(nonPurchasedProducts, "categories");

        let result = {};
        for (const key of ancestryKeys) {
          if (storeList.value && storeList.value[key] && storeList.value[key].length > 0) {
            result = storeList.value[key][0];
            break;
          }
        }

        if (buildVersion !== "dnanalysis") {
          getAllProducts({
            barcode: myProfile?.barcode,
            where: {
              age_tags_any: ["All-Ages", patientStore.patient.ageGroup],
              gender_tags_any: [patientStore.patient.bioSex],
              wellbeing_goal_tags_any: patientStore.patient.questionnaireAnswers?.wellbeing_goals,
            },
          })
            .then((products) => {
              const groupedProducts = groupBy(products, "product_type");

              // Owned genetic tests are already left out by the store; anything else flagged
              // `purchased` is dropped here.
              const filteredGroupedProducts = {};
              Object.keys(groupedProducts).forEach((key) => {
                filteredGroupedProducts[key] = groupedProducts[key].filter(
                  (product) => product.purchased === false
                );
              });
              productList.value = filteredGroupedProducts;
            })
            .finally(() => {

              let healthresult = {};
              for (const key of healthKeys) {
                if (productList.value && productList.value[key] && productList.value[key].length > 0) {
                  healthresult = productList.value[key][0];
                  break;
                }
              }
              if (healthresult)
                healthImage.value = (healthresult.header_image !== null && healthresult?.header_image?.length > 0) ? healthresult.header_image[0].url : '';
              healthTitle.value = healthresult.product_name;
              healthLink.value = healthresult._id;
              healthType.value = healthresult.product_type;
              healthrate.value = healthresult.price_string;

            });
        }

        unlockImage.value = result.image;
        unlockTitle.value = result.title;
        unlockLink.value = result.slug;
        unlockrate.value = result?.currencySymbol?.raw + getPrice(result?.price);
      }
    }

    onMounted(async () => {
      if (store.getters?.profile?.permission?.type === 'MANAGER') {
        hasHealthProfileAccess.value = await checkProfileManager(myProfile?.barcode);
      }
      if (buildVersion !== 'dnanalysis' && hasHealthProfileAccess.value && !myProfile?.barcode?.endsWith('E')) {
        await patientStore.getPatient().catch(() => { });
      }
      activeTab.value = '';
      showOnboardingModals();
      getStoreList();
      getBakersData();
    });

    const isActive = (paths) => {
      if (Array.isArray(paths)) {
        return paths.some(path => {
          return route.path.includes(path)
        })
        // return paths.includes(route.path);
      }
      return route.path === paths;
    };

    const openModal = () => {
      componentsStore.openChangeProfileModal();
    };
    const openhelpModal = () => {
      componentsStore.openChangeHelpModal();
    };

    // Blood tests are no longer sold: the menu only leads customers who have one to their results.
    const hasBloodTests = computed(() => Boolean(patientStore.patient?.tests?.length));

    const closeModal = () => {
      componentsStore.clodeChangeProfileModal(); componentsStore.clodeChangeHelpModal();
      showEpiIntroModal.value = false;
      navChooserDomain.value = null;
      isResultModalVisible.value = false;
      isAncestryDontModalVisible.value = false;
      isHealthTestMessageModalVisible.value = false;
      isHealthTestDontMessageModalVisible.value = false;
      isUpgradeMessageModalVisible.value = false;
    };

    return {
      isActive,
      bakersResult,
      loadingStatus,
      openModal,
      openhelpModal,
      closeModal,
      hasBloodTests,
      componentsStore,
      activeTab,
      hasHealthProfileAccess,
      useNewWellbeing,
      useNewBaker,
      buildVersion,
      unlockTitle,
      unlockLink,
      unlockrate,
      unlockImage,
      getStoreList,
      healthImage,
      healthTitle,
      healthLink,
      healthType,
      healthrate,
      isResultModalVisible,
      isAncestryDontModalVisible,
      isHealthTestMessageModalVisible,
      isHealthTestDontMessageModalVisible,
      isUpgradeMessageModalVisible,
      showOnboardingModals,
      isEpigenetics,
      epigeneticsProfileId,
      resolveDomainEntry,
      switchToProfile,
      showEpiIntroModal,
      navChooserDomain,
      HEALTH,
      ANCESTRY,
    };
  },
  data() {
    return {
      showDropdown: false,
      ProfileIcon,
      ChangeProfileIcon,
      LogoutIcon,
      menuActive: false,
      activeSubMenuIndex: null,
      activeSubMenuUpIndex: null
    };
  },
  methods: {
    toggleMenu() {
      this.menuActive = !this.menuActive;

    },

    toggleSubMenu(index) {
      this.activeSubMenuIndex = this.activeSubMenuIndex === index ? null : index;
    },

    handleClickUpOutside(event) {
      const ancestryMenu = this.$refs.ancestryMenu;
      const healthMenu = this.$refs.healthMenu;

      if (
        (ancestryMenu && !ancestryMenu.contains(event.target)) &&
        (healthMenu && !healthMenu.contains(event.target))
      ) {
        this.activeSubMenuUpIndex = null;
      }
    },
    toggleSubUpMenu(index) {

      this.activeSubMenuUpIndex = this.activeSubMenuUpIndex === index ? null : index;
    },
    // Resolve what happens when the user asks to go to another domain:
    //  swap (one target) → switch straight in; choose (several) → open the switcher
    //  filtered to that domain; upsell (none) → epigenetics interstitial / add ancestry kit.
    async goToDomain(targetDomain) {
      try {
        const res = await this.resolveDomainEntry(targetDomain);
        if (res.action === 'swap') {
          await this.switchToProfile(res.target);
          if (targetDomain === this.HEALTH) this.$router.push({ name: 'epigenetics-overview' });
          else this.$router.go();
        } else if (res.action === 'choose') {
          this.navChooserDomain = targetDomain;
          this.componentsStore.openChangeProfileModal();
        } else {
          if (targetDomain === this.HEALTH) this.showEpiIntroModal = true;
          else this.$router.push({ name: 'add-profile' });
        }
      } catch (e) {
        console.error('domain nav resolution failed', e);
      }
    },
    onEpigeneticsClick() {
      // Already in the health context → their own epigenetics results; otherwise resolve.
      if (this.isEpigenetics) this.$router.push({ name: 'epigenetics-overview' });
      else this.goToDomain(this.HEALTH);
    },
    exploreEpigeneticKits() {
      this.showEpiIntroModal = false;
      this.$router.push({ name: 'HealthStore', query: { tab: 'epigenetickits' } });
    },
    handleAncestryDesktopClick() {
      if (this.isEpigenetics) {
        this.goToDomain(this.ANCESTRY);
        this.activeTab = 'ancestery';
      } else {
        this.toggleSubUpMenu(0);
        this.activeTab = 'ancestery';
      }
    },
    handleAncestryMobileClick() {
      if (this.isEpigenetics) {
        this.goToDomain(this.ANCESTRY);
        this.menuActive = false;
      } else {
        this.toggleSubMenu(0);
      }
    },
    handleClickOutside(event) {
      if (
        this.$refs.sidebar &&
        !this.$refs.sidebar.contains(event.target) &&
        !this.$refs.toggler.contains(event.target)
      ) {
        this.menuActive = false;
      }
    },
    logout() {
      this.$store.dispatch("logout");
      // this.$router.push({name: 'login'});
      window.location.href = "/signin";
    }
  },
  async beforeMount() {
    if (isAuthenticated()) {
      await store.dispatch("fetchProfile");

      if (isEmpty(store.getters.profile)) {
        this.$router.push({ name: "activation" });
      }
    } else {
      this.logout();
    }
  },
  async mounted() {
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("click", this.handleClickUpOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("click", this.handleClickUpOutside);
  },
  computed: {
    profile() {
      return store.getters["profile"].profile;
    },
    profileInitials() {
      const name = store.getters["profile"].profile?.name || "";
      return name.trim().split(" ").map(p => p[0]).join("").toUpperCase().slice(0, 2) || "?";
    },
  },
};


</script>

<style>
.actives {
  color: #1a3b84 !important;
  /* Change this to the color you want for the active menu */
  font-weight: 600 !important;
  font-size: 17px !important;
}

.store-nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
